<template>
  <div class="container" v-title :data-title="$t('i18n.blacklist')">
    <div id="outer-title">{{ $t("i18n.blacklist") }}</div>
    <div v-loading="loading">
      <jl-table
        :tableData="tableData"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @getEditData="getEditData"
        @init="init"
        :options="options"
        :columns="columns"
        :operates="operates"
        :total="total"
        :height="$defined.HEIGHT - 360 + 'px'"
      >
      </jl-table>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import jlTable from "../../components/table";
export default {
  name: "BlackList",
  components: {
    jlTable,
  },
  setup(props, { emit }) {
    emit("public_header", true);
    const { proxy } = getCurrentInstance();
    const { t } = useI18n();
    const state = reactive({
      formInline: {
        pageNumber: 1,
        pageSize: 10,
      },
      // table数据
      tableData: [],
      options: {
        // table 的参数
        isAdd: proxy.$defined.btnPermission("添加黑名单"), // 是否启用新增功能
        isEdit: proxy.$defined.btnPermission("编辑黑名单"), // 是否启用编辑功能
        isDelete: proxy.$defined.btnPermission("删除黑名单"), // 是否启用删除功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        multiSelect: false, // 是否支持列表项选中功能
        pageShow: true, // 是否翻页
      },
      columns: [
        // 需要展示的列
        {
          prop: "lostTrustee",
          label: "lostTrustee",
          align: "center",
          search: true,
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
        {
          prop: "lostType",
          label: "lostType",
          align: "center",
          search: true,
          type: "select",
          props: { label: "locale", value: "id" },
          data: [
            { id: 10, locale: "naturalPerson" },
            { id: 20, locale: "legalOrg" },
          ],
          rules: [{ required: true, message: t("i18n.input") }],
          formatter: (row) => {
            let val = row.lostType == 10 ? "naturalPerson" : "legalOrg";
            return t("i18n." + val);
          },
        },
        {
          prop: "organizationCode",
          label: "orCode",
          align: "left",
          type: "input",
          rules: [{ required: true, message: t("i18n.input") }],
        },
      ],
      operates: {
        // 列操作按钮
        width: 140,
        fixed: "right",
        list: [],
      },
      total: 0,
      loading: true,
      editData: {},
    });

    const init = async (params) => {
      state.loading = true;
      const { data } = await proxy.$api.supervision.blackPages(params);
      state.tableData = data.records;
      state.total = data.total;
      state.loading = false;
    };

    const handleEdit = async (val, pages) => {
      // 新增/编辑数据
      let msg = val.id ? "edit" : "new";
      if (val.id) {
        for (let k in val) {
          if (val[k] !== undefined) {
            state.editData[k] = val[k];
          }
        }
        val = JSON.parse(JSON.stringify(state.editData));
      }
      val.id
        ? await proxy.$api.supervision.editBlack(val.id, val)
        : await proxy.$api.supervision.addBlack(val);
      proxy.$defined.tip(t("i18n." + msg) + t("i18n.success"), "success");
      // 初始化 刷新
      init(pages);
    };

    const handleDelete = (row, pages) => {
      proxy.$api.supervision.delBlack(row.id).then(() => {
        init(pages);
        proxy.$defined.tip(t("i18n.delete") + t("i18n.success"), "success");
      });
    };

    const getEditData = (row) => {
      state.editData = row;
    };

    return {
      ...toRefs(state),
      handleEdit,
      init,
      handleDelete,
      getEditData,
    };
  },
};
</script>
